export const NODE_SIZE = 40;
export const LINK_LENGTH_CONSTANT = 500;
export const MAX_NODES = 500;
export const HIGHLIGHT_ALPHA = 0.0;
export const CANVAS_COLOR = "white";